// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"961b7d8e","348":"72ba3a37","473":"489899aa","593":"b86bc160"}[chunkId] + ".chunk.css";
};